<!-- 
CreditCardValidation.vue
功能：信用卡身分驗證異常名單
作者：i9400538 陳博承
完成：2022-04-26
-->
<template>
  <div>
    <div class="container-fluid" style="overflow: hidden;">
      <div
        class="mb-3"
        :class="{'section-loading': infoLoading}"
        style="overflow: hidden;max-height: 140px;"
      >
        <div class="float-left w-75">
          <h4 class="mb-line text-green mt-0 mb-0">
            {{ categoryInfo.subcategory }}-{{ categoryInfo.category_name }}
            <a
              v-if="categoryInfo.upload_file"
              class="text-orange"
              style="text-decoration:none;"
            >
              <i style="cursor:pointer;" class="icon-attach ml-2" @click="download()"></i>點我
            </a>
          </h4>
          <div class="mb-line" style>
            <span
              class="font-weight-bold mr-2"
            >{{ categoryInfo.upload_date | dateFormat }} ~ {{ categoryInfo.end_date | dateFormat }}</span>
          </div>
          <div class="mb-line w-75">
            <span class="font-weight-bold mr-2">{{ categoryInfo.description }}</span>
          </div>
        </div>
        <div class="float-left w-25">
          <div class="mb-line">
            <span class="font-weight-bold mr-2">維護單位</span>
            <span>{{ categoryInfo.dev_name }}</span>
          </div>
          <div class>
            <span class="font-weight-bold mr-2">聯絡電話</span>
            <span>{{ categoryInfo.contact }}</span>
          </div>
          <div class="mb-line">
            <span class="font-weight-bold mr-2">聯絡分機</span>
            <span>{{ categoryInfo.contact_tel }}</span>
          </div>
          <div :class="{'section-loading': isLoading_btn}">
            <a class="btn btn-default m-0" @click="satisfactionModal" v-if="isBtnEnble">滿意度調查</a>
            <a class="btn btn-default m-0" @click="alreadyDone" disabled="disabled" v-else>滿意度調查</a>
            &nbsp;&nbsp;
            <button
              type="button"
              style="height:43px;"
              @click="backToIndex"
              class="position-absolute btn btn-default m-0"
              v-html="'<span style=\'font-size:1rem\'>回上一頁<span>'"
            ></button>
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
    <div class="container-fluid" :class="{'section-loading': isLoading}">
      <div class="row">
        <credit-card-validation-data-table
          :height="data_table_height"
          @update="updateSelection"
          @detail-modal-open="CreditCardDetailOpen"
          :table-data="tableData"
        />
      </div>
    </div>

    <section class="container-fluid fixed-bottom">
      <div class="row">
        <div class="col-12"></div>
        <div class="col-9 col-sm-8 col-md-8"></div>
        <div class="col-3 col-sm-4 col-md-4 text-right">
          <button
            class="btn btn-primary"
            @click="panelOpen('groupModalOpen')"
            :disabled="!selection.length"
          >加入群組</button>
          <button
            class="btn btn-primary mr-0"
            @click="panelOpen('printModalOpen')"
            :disabled="!selection.length"
          >列印名條</button>
        </div>
      </div>
    </section>

    <!-- 列印名條 -->
    <print-modal :open="printModalOpen" :custs="selection" @close="panelClose('printModalOpen')" />

    <!-- 加入群組 -->
    <group-modal
      :open="groupModalOpen"
      :custs="selection"
      @submit="submitGroup"
      @close="panelClose('groupModalOpen')"
    />

    <!-- 滿意度調查 -->
    <satisfaction-modal
      :open="satisfactionModalOpen"
      @report="report"
      @close="panelClose('satisfactionModalOpen')"
    />

    <!-- 信用卡身分驗證異常名單-明細查詢 -->
    <credit-card-detail-modal
      :open="CreditCardDetailModalOpen"
      :tableData="authData"
      @close="panelClose('CreditCardDetailModalOpen')"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { commonMixin } from "@/mixins/common";
//component
import PrintModal from "@/desktop/components/PrintModal";
import GroupModal from "@/desktop/components/GroupModal";
import CreditCardDetailModal from "@/desktop/components/ListsArea/CreditCardDetailModal";
import CreditCardValidationDataTable from "@/desktop/components/ListsArea/DataTable/CreditCardValidationDataTable";
import SatisfactionModal from "@/desktop/components/ListsArea/SatisfactionModal";
//service
import {
  getCreditCardValidationList,
  getCategoryDetail,
  isSatisfactionSurveyFinish,
  downloadFile_m0
} from "@/service";
import { saveAs } from "file-saver";

export default {
  name: "CreditCardValidation",
  mixins: [commonMixin],
  components: {
    CreditCardValidationDataTable,
    SatisfactionModal,
    PrintModal,
    GroupModal,
    CreditCardDetailModal
  },
  data() {
    //data block layout
    return {
      isLoading_btn: true,
      isLoading: false,
      infoLoading: false,
      isBtnEnble: true,
      categoryInfo: {},
      printModalOpen: false,
      groupModalOpen: false,
      tableData: [],
      selection: [],
      satisfactionModalOpen: false,
      data_table_height: 0,
      CreditCardDetailModalOpen: false,
      authData: [] //相同授權書資料
    };
  },
  methods: {
    ...mapActions(["setPageLock", "updateCustID"]),
    updateSelection(val) {
      this.selection = val;
    },
    PrintModal() {
      this.panelOpen("printModalOpen");
    },
    satisfactionModal() {
      this.panelOpen("satisfactionModalOpen");
    },
    report() {
      this.$toast.info({ title: "滿意度調查 已回報" });
      this.isBtnEnble = false;
      this.panelClose("satisfactionModalOpen");
    },
    //回上一頁
    backToIndex() {
      this.$emit("change-status", "STATUS_SERVICE_RIGHT_LIST");
    },
    //加入群組導頁至 群組列表
    submitGroup(group) {
      this.panelClose("groupModalOpen");
      this.$router.push({
        path: `/group/1`,
        query: { grp_id: group.grp_id, grp_name: group.grp_name }
      });
    },
    //明細查詢
    CreditCardDetailOpen(data) {
      this.authData = data.detail || [];
      this.panelOpen("CreditCardDetailModalOpen");
    },
    //取得性別
    getGender(csid) {
      if (!csid || !csid.trim()) {
        return;
      }
      let id = csid.toUpperCase();
      let gender = "";
      if (id.match("1|8|A|C")) {
        gender = 1;
      } else if (id.match("2|9|B|D")) {
        gender = 2;
      }
      return gender;
    },
    init() {
      // 資料初始化
      this.checkIsSatisfactionSurveyFinish();
      this.isLoading = true;
      getCreditCardValidationList(this.$store.state.userInfo.id).then(
        result => {
          this.isLoading = false;
          if (
            result.header &&
            result.header.status === "200" &&
            result.body.result &&
            result.body.result.length
          ) {
            let rtnList =
              result.body.result.map(item => {
                item.sex = this.getGender(item.apc_id); //要保人性別
                return item;
              }) || [];

            //整理相同授權書資料(detail)
            let tempAuthNo = "";
            for (let i = 0; i < rtnList.length; i++) {
              if (tempAuthNo != rtnList[i].auth_no) {
                rtnList[i].detail = [];
                rtnList[i].detail.push(rtnList[i]);
                tempAuthNo = rtnList[i].auth_no;
                this.tableData.push(rtnList[i]);
              } else {
                this.tableData[this.tableData.length - 1].detail.push(
                  rtnList[i]
                );
              }
            }
            this.registerHanlink(); // for hard word
          } else {
            this.tableData = [];
          }
        }
      );
      this.getTitleInfo();
    },
    getTitleInfo() {
      // 取得專區資訊
      this.infoLoading = true;
      getCategoryDetail(
        this.$store.state.userInfo.id,
        this.$store.state.listAreaSerNo
      ).then(result => {
        this.infoLoading = false;
        if (result.header && result.header.status == "200") {
          this.categoryInfo = result.body[0];
        }
      });
    },
    checkIsSatisfactionSurveyFinish() {
      // 檢查是否已回報過滿意度調查
      this.isLoading_btn = true;
      isSatisfactionSurveyFinish(
        this.$store.state.userInfo.id,
        this.$store.state.listAreaSerNo
      ).then(result => {
        if (result.header && result.header.status == "200") {
          this.isBtnEnble = result.body.isfinish == "0";
        } else {
          if (result.header && result.header.message) {
            this.$toast.info({ title: result.header.message });
          } else {
            this.$toast.info({ title: "查詢滿意度調查失敗,請重新操作" });
          }
        }
        this.isLoading_btn = false;
      });
    },
    alreadyDone() {
      this.$toast.info({ title: "您已回報過滿意度調查,無法重複操作" });
    },
    download() {
      if (this.$store.state.userInfo.userType === "box") {
        //若内嵌於Box, 將檔案資訊回傳給Box
        this.boxDownload(
          this.categoryInfo.upload_file,
          this.categoryInfo.ser_no
        );
      } else {
        let vm = this;
        downloadFile_m0(
          this.$store.state.userInfo.id,
          this.categoryInfo.ser_no,
          this.categoryInfo.upload_file
        ).then(result => {
          if (result.type == "application/json") {
            //  json 為檔案下載失敗
            //  把回傳的 blob 轉為 文字檔後再用 json parse
            let reader = new FileReader();
            reader.onload = function() {
              let unicodeJsonA = JSON.parse(reader.result);
              if (unicodeJsonA.header.message) {
                vm.setToastMsg(unicodeJsonA.header.message);
              } else {
                vm.setToastMsg("伺服器連線異常");
              }
            };
            reader.readAsText(result);
          } else {
            //  成功取得檔案  進行下載
            saveAs(result, this.categoryInfo.upload_file);
          }
        });
      }
    }
  },
  mounted() {
    // 資料初始化
    this.init();
    this.data_table_height =
      parseInt($(window).height()) - $("tbody").offset().top - 80;
    let self = this;
    $(window).bind("resize", function(event) {
      self.data_table_height =
        parseInt($(window).height()) - $("tbody").offset().top - 80;
    });
    $(".tab-content").css("padding-bottom", "74px");
  }
};
</script>
